import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Generate a SEO-friendly URL slug from a title + year.
 * Must match the Python `_make_title_slug` / `_make_hub_slug` logic in server.py exactly.
 * Step 1: strip punctuation chars (apostrophes, commas, quotes, etc.) → empty string
 * Step 2: replace whitespace, underscores, slashes → hyphen
 * Step 3: collapse consecutive hyphens, trim leading/trailing hyphens
 * e.g. titleSlug("India's Got Latent", 2024) → "indias-got-latent-2024"
 */
export function titleSlug(title = "", year = "") {
  const s = (title || "")
    .toLowerCase()
    .replace(/['",.:!?&@#()\[\]{}]+/g, "")  // strip punctuation → empty string
    .replace(/[\s_/\\]+/g, "-")              // whitespace / underscore / slash → hyphen
    .replace(/-{2,}/g, "-")                  // collapse consecutive hyphens
    .replace(/^-+|-+$/g, "");               // trim leading/trailing hyphens
  const base = s || "untitled";
  return year ? `${base}-${year}` : base;
}

/**
 * Build a React Router path for a title detail page using SEO slug URL.
 * Falls back to numeric ID if title or year is unavailable — prevents
 * year-less slugs like "django-unchained" that 404 because the registry
 * only knows the canonical "django-unchained-2012".
 */
export function buildTitleUrl(mediaType, title, year, tmdbIdFallback) {
  if (title && year) return `/title/${mediaType}/${titleSlug(title, year)}`;
  if (tmdbIdFallback) return `/title/${mediaType}/${tmdbIdFallback}`;
  return `/title/${mediaType}/${titleSlug(title, year)}`;
}
